import { api } from "./api";

export async function getSheduleData(date: string) {
    try {
        const response = await api.get("appointments", {
            withCredentials: true,
            params: { date },
        });
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return { message: "Щось пішло не так" };
        }
    }
}
